import {
  Button,
  TextField,
  Autocomplete,
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  MenuItem,
  Theme,
  useTheme,
  Grid,
  FormHelperText,
  Skeleton,
  Tooltip,
  IconButton,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@mui/material';
import {
  PublicService,
  LocalService,
  UserService,
} from '../../../../core/services';
import './personal_info.scss';
import dayjs from 'dayjs';
import React, { useEffect, useRef, useState } from 'react';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import FileUploadPopup from '../../../../components/popup/file-upload-popup';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { FormValidation } from '../../../../core/utility';
import { Methods } from '../../../../core/utility';
import { Loading } from '../../../../redux/action';
import { connect } from 'react-redux';
import { UserLogin } from '../../../../redux/action';
import { DefaultUserProfile } from '../../../../config/config';
import { MenuPropsAutoComplete, MenuPropsAutoCompleteNoCheckBox, MenuPropsSelect } from '../../../../core/utility/style';
import * as gtUtil from "../../../../core/utility";
import { LoadingButton } from '@mui/lab';
import { MuiOtpInput } from 'mui-one-time-password-input';
import MaterialSymbol from '../../../../components/icons/material-symbol';
import SendIcon from "@mui/icons-material/Send";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import { parsePhoneNumberFromString } from 'libphonenumber-js';

// Create an instance of LocalService class
const localService: LocalService = new LocalService();
// Create an instance of UserService class
const userService: UserService = new UserService();
// To use predefined methods, to calculate age and get formatted date
const platformMethod = new Methods();

interface Props {
  loading: (data: any) => any;
  userData: any;
  updateUser: any;
  updateAccountImage: (data: any) => void;
}

interface whats_app_boolean_fields {
  disableWhatsappfieldInput: boolean;
  disableWhatsappfield: boolean;
  verifiedfield: boolean;
  isEditButtonDisabled: boolean;
  isResendButtonDisabled: boolean;
  isTimerDisabled: boolean;
  showResendEdit: boolean;
  showotpBox: boolean;
  verifiedWAfield: boolean;
}

interface email_boolean_fields {
  disableEmailfieldInput: boolean;
  disableEmailField: boolean;
  verifiedEmail: boolean;
  isEditButtonEmailDisabled: boolean;
  isResendButtonEmailDisabled: boolean;
  isEmailTimerDisabled: boolean;
  showEmailResendEdit: boolean;
  showEmailotpBox: boolean;
  verifiedEmailfield: boolean;

}

const default_whats_app_boolean_fields: whats_app_boolean_fields = {
  disableWhatsappfieldInput: false,
  disableWhatsappfield: true,
  verifiedfield: false,
  isEditButtonDisabled: false,
  isResendButtonDisabled: true,
  isTimerDisabled: true,
  showResendEdit: false,
  showotpBox: false,
  verifiedWAfield: false
};

const default_email_boolean_fields: email_boolean_fields = {
  disableEmailfieldInput: false,
  disableEmailField: true,
  verifiedEmail: false,
  isEditButtonEmailDisabled: false,
  isResendButtonEmailDisabled: true,
  isEmailTimerDisabled: true,
  showEmailResendEdit: false,
  showEmailotpBox: false,
  verifiedEmailfield: false
};

const InfluencerPersonalInfo: React.FC<Props> = (props: Props) => {
  const theme = useTheme();
  // const dispatch = useDispatch();
  const [disableField, setDisableField] = useState(true);
  const [buttonName, setButtonName] = useState('Edit');
  // Create new instance from FormValidation class
  const formValidation = new FormValidation();
  // Set influencer_id from props
  // Set form fields
  const [formData, setFormData] = useState({
    user_id: props.userData.user_id,
    influencer_id: props.userData.influencer_id,
    account_id: props.userData.account_id,
    account_type: props.userData.account_type,
    name: '',
    dob: '',
    gender: '',
    photo: '',
    primary_phone: '',
    phone_otp: '',
    primary_email: '',
    email_otp: '',
    category_ids: [],
    location_id: 0,
    country: '',
    state: '',
    city: '',
    state_id: '',
    city_id: '',
    country_id: '',
    age: '',
    dial_code: '91',
    country_dial_code: ''
  });

  // Set form error fields
  const [formError, setFormErrors] = useState<any>({
    name: { status: true, message: '' },
    category_ids: { status: true, message: '' },
    location_id: { status: true, message: '' },
    primary_email: { status: true, message: '' },
    primary_phone: { status: true, message: '' }
  });

  const [country, setCountry] = useState<any[]>([]);
  const [states, setStates] = useState<any[]>([]);
  const [cities, setCities] = useState<any[]>([]);
  const [allCountries, setAllCountries] = useState<any[]>([]);
  const onlyCountries = allCountries
    .map((c: any) => c.country_code?.toLowerCase())
    .filter(Boolean);
  // To set selected location
  const [selectedCountry, setSelectedCountry] = React.useState<string>('');
  const [selectedState, setSelectedState] = React.useState<string>('');
  const [selectedCity, setSelectedCity] = React.useState<string>('');
  const [initialCountry, setInitialCountry] = React.useState<string>('');
  const [initialState, setInitialState] = React.useState<string>('');
  const [initialCity, setInitialCity] = React.useState<string>('');
  const [showDialCodeChangeWarning, setShowDialCodeChangeWarning] = useState(false);
  const [initialDialCode, setInitialDialCode] = useState<string>('');
  const [countryDialCode, setCountryDialCode] = useState<string>('');
  // To store all categories from master_categories
  const [masterCategories, setMasterCategories] = useState<string[]>([]);
  //For camera icon state 
  const [cameraIcon, setCameraIcon] = useState(false);
  //For Popup open state while upload image
  const [showUploadPopup, setShowUploadPopup] = useState<any>(false);
  //For Editable Field 
  const [editableFields, setEditableFields] = useState({
    name: false,
    primary_email: false,
    primary_phone: false,
    gender: false,
    genre: false,
    location: false
  });
  //path for image upload on AWS
  const path = `accounts/${props.userData.account_id}/users`
  // For Photo update only
  const [updatedPhoto, setUpdatedPhoto] = useState<string>("");

  const [loading, setLoading] = useState(false)

  const [showotpBox, setOtpBox] = useState(false);
  const [whats_app_boolean_fields, set_whats_app_boolean_fields] = useState<whats_app_boolean_fields>(() => {
    const savedData = localStorage.getItem('whats_app_boolean_fields');
    return savedData ? JSON.parse(savedData) : default_whats_app_boolean_fields;
  });

  const [email_boolean_fields, set_email_boolean_fields] = useState<email_boolean_fields>(() => {
    const savedData = localStorage.getItem('email_boolean_fields');
    return savedData ? JSON.parse(savedData) : default_email_boolean_fields;
  });

  const phoneRef = useRef<any>(null);

  const [whatsappnumber, setWhatsAppNumber] = useState("");

  const [phoneloading, setPhoneLoading] = useState(false);

  const [timer, setTimer] = useState(60);

  const [otpWhatsAppValue, setOtpWhatsAppValue] = React.useState<string>('')

  const [otpEmailValue, setOtpEmailValue] = React.useState<string>('')

  const [emailOtpVerifyloading, setEmailOtpVerifyLoading] = useState(false);

  const [phoneOtpVerifyloading, setPhoneOtpVerifyLoading] = useState(false);

  const [verifiedEmailfield, setVerifiedEmailfield] = useState(false);

  const [email, setEmail] = useState("");

  const [emailOtpSent, setEmailOtpSent] = useState(false);

  const [emailloading, setEmailLoading] = useState(false);

  const [emailOtpError, setEmailOtpError] = useState<boolean>(false);

  const [phoneOtpError, setPhoneOtpError] = useState<boolean>(false);

  const [phoneOtpErrorMsg, setPhoneOtpErrorMsg] = useState<string>('Wrong One Time Password (OTP)');

  const [emailOtpErrorMsg, setEmailOtpErrorMsg] = useState<string>('Wrong One Time Password (OTP)');

  const emailRef = useRef<any>(null);

  const [Emailtimer, setEmailTimer] = useState(60);

  const [toggleClass, setToggleClass] = useState<boolean>(false)

  const [toggleClassForOther, setToggleClassForOther] = useState<boolean>(false)

  const [initialFormData, setInitialFormData] = useState(formData);

  const publicService = new PublicService();

  useEffect(() => {
    publicService.getCountry({})
      .then((res: any) => {
        if (res?.status === 1) setAllCountries(res.data || []);
        else setAllCountries([]);
      })
      .catch(() => setAllCountries([]));
  }, []);

  useEffect(() => {
    props.loading(true);
    setLoading(true)
    userService.getInfluencerDetails(`${props.userData.influencer_id}`)
      .then((res) => {
        // Set category ids in the form of array.
        if (res?.data?.rows[0]?.category_ids !== '') {
          res.data.rows[0].category_ids = res.data.rows[0]?.category_ids?.split(',')
        } else {
          res.data.rows[0].category_ids = []
        }
        // // Set Account Form data
        // setFormData(res.data.rows[0]);
        // setInitialFormData(res.data.rows[0])

        // // set age as per existing dob if exist
        // let changedAge = platformMethod.calculateAge(res.data.rows[0]?.dob);
        // if (changedAge !== undefined && changedAge !== null) {
        //   setFormData({
        //     ...formData,
        //     ...res.data.rows[0],
        //     age: (changedAge.toString())
        //   });
        // }
        let changedAge = platformMethod.calculateAge(res.data.rows[0]?.dob);
        const updatedData = {
          ...formData,
          ...res.data.rows[0],
          age: changedAge !== undefined && changedAge !== null ? changedAge.toString() : '',
        };

        // Set Account Form data
        setFormData(updatedData);
        setInitialFormData(updatedData);

        // To set existing location values from IDs
        const loadedCountryId = res?.data.rows[0]?.country_id ? String(res.data.rows[0].country_id) : '';
        const loadedStateId = res?.data.rows[0]?.state_id ? String(res.data.rows[0].state_id) : '';
        const loadedCityId = res?.data.rows[0]?.city_id ? String(res.data.rows[0].city_id) : '';

        setSelectedCountry(loadedCountryId);
        setSelectedState(loadedStateId);
        setSelectedCity(loadedCityId);
        setInitialCountry(loadedCountryId);
        setInitialState(loadedStateId);
        setInitialCity(loadedCityId);
        setInitialDialCode(res?.data.rows[0]?.dial_code || '91');
        setCountryDialCode(res?.data.rows[0]?.country_dial_code || '91');
        // Remove loader
        props.loading(false);
        setLoading(false)
      })

    PublicService.getGenre().then((res) => {
      setMasterCategories(res?.data?.rows);
      //remove loader
      props.loading(false);
    });
  }, [disableField]);

  // Calculate the minimum date (100 years ago)
  const minDate = new Date();
  minDate.setFullYear(minDate.getFullYear() - 100);

  // Calculate the maximum date (4 years ago)
  const maxDate = new Date();
  maxDate.setFullYear(maxDate.getFullYear() - 4);

  //Element Heights
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;

  const isValidPhoneNumber = (
        phone: string,
        dialCode: string
      ) => {
        const fullNumber = `+${dialCode}${phone}`;
    
        const phoneNumber = parsePhoneNumberFromString(fullNumber);
    
        return phoneNumber?.isValid() || false;
    };

  // Extra component
  function getStyles(name: string, personName: string[], theme: Theme) {
    try {
      return {
        fontWeight:
          personName.indexOf(name) === -1
            ? theme.typography.fontWeightRegular
            : theme.typography.fontWeightMedium,
      };
    } catch (error) { }
  }

  async function updateUserReducer() {
    let latestUserReducerData = await userService.getUpdatedUserReducer(props.userData);
    if (![undefined, null, ''].includes(latestUserReducerData)) {
      props.updateUser(latestUserReducerData)
    }
  }

  const handlePersonalInfoFormData = async (e?: any) => {
    if (e) e.preventDefault(); // Prevent default only if event exists
    try {
      // Validate form
      const validateName = formValidation.GetNameValidate(formData.name);
      const validateGenre = formValidation.GenreControlIsValid(formData.category_ids);
      // const validateLocationId = formValidation.LocationControlIsValid(formData.location_id);

      setFormErrors({
        name: { ...validateName },
        category_ids: { ...validateGenre },
        // location_id: { ...validateLocationId },
      });

      if (buttonName === 'Edit') {
        setButtonName('Update');
        setDisableField(false);
        setCameraIcon(true);
      }

      if (validateName.status && validateGenre.status) {
        try {
          const res = await userService.updateInfluencerDetails(formData);
          if (res.status === gtUtil.Constants.SUCCESS) {
            props.updateAccountImage({ ...props.userData, ...formData });
            localService.toastify(res.info, 'success', 1000);
            setEditableFields({
              name: false,
              primary_email: false,
              primary_phone: false,
              gender: false,
              genre: false,
              location: false
            });
            // setFormData(initialFormData);
            setToggleClass(false)
            setToggleClassForOther(false)
            set_email_boolean_fields(prevState => ({
              ...prevState,
              isEditButtonEmailDisabled: false,
              showEmailotpBox: false,
              isResendButtonEmailDisabled: false,
              isEmailTimerDisabled: false,
              showEmailResendEdit: false,
              disableEmailfieldInput: false,
              disableEmailField: false,
              verifiedEmail: false,
              verifiedEmailfield: false
            }));
            set_whats_app_boolean_fields(prevState => ({
              ...prevState,
              verifiedfield: false,
              disableWhatsappfieldInput: false,
              disableWhatsappfield: false,
              isEditButtonDisabled: false,
              isResendButtonDisabled: false,
              isTimerDisabled: false,
              showResendEdit: false,
              showotpBox: false,
              verifiedWAfield: false
            }));
            setOtpEmailValue('')
            setOtpWhatsAppValue('')
            setButtonName('Edit');
            setDisableField(true);
            setCameraIcon(false);
            updateUserReducer();
          } else {
            localService.toastify(res.info, 'error', 1000);
          }
        } catch (error) {
          console.error(`Handle Personal Info Save Error ::`, error);
        }
      }
    } catch (error) {
      console.error(`Influencer Account Update function error ::`, error);
    } finally {
      props.loading(false);
    }
  };


  // To handle dob
  const handleDob = (event: any) => {
    let birthDate = event.$d;
    let formatted_date = platformMethod.getDateMySQL(birthDate);
    setFormData({
      ...formData,
      dob: formatted_date
    });
    let changedAge = platformMethod.calculateAge(birthDate);
    let ageElement = document.getElementById('age');
    if (changedAge != undefined && changedAge != null && ageElement) {
      setFormData({
        ...formData,
        age: (changedAge.toString())
      });
    }
  };

  // To handle genre
  const handleGenre = (event: any) => {
    const {
      target: { value },
    } = event;
    if (formData?.category_ids?.length != 3) {
      setFormData({
        ...formData,
        category_ids: value
      });
      // setGenre(value);
    } else {
      if (value.length === 2) {
        setFormData({
          ...formData,
          category_ids: value
        });
      } else {
        setFormData({
          ...formData,
          category_ids: []
        });
      }
    }
  };

  // Country + phone dial code are LOCKED to the account's signup region — they
  // drive billing currency and the foreign (Zap-only) flow, so the user must not
  // change them here. Point them to support instead.
  const notifyLockedRegionField = () => {
    localService.toastify('Your country and phone code are fixed to your account. To change them, please contact support.', 'info', 3000);
  };

  const handleCountryChange = (_e: any, _selectedCountry: any) => {
    // Blocked — the controlled `value` keeps the current (locked) country.
    notifyLockedRegionField();
  };

  const handleStateChange = (_e: any, selectedState: any) => {
    setSelectedState(selectedState?.id || '');
    setSelectedCity('');
    setCities([]);
    setFormData((prev) => ({
      ...prev,
      location_id: 0,
      state_id: selectedState?.id || '',
      city_id: '',
    }));
  };

  const handleCityChange = (_e: any, selectedCity: any) => {
    setSelectedCity(selectedCity?.id || '');

    setFormData((prev) => ({
      ...prev,
      location_id: 0,
      city_id: selectedCity?.id || '',
    }));
  };

  const getCountry = async (dialingCode: string) => {
    try {
      const cleanDialCode = String(dialingCode || '').replace(/^[+]/, '');
      if (!cleanDialCode) {
        setCountry([]);
        setStates([]);
        setCities([]);
        return;
      }

      const response = await publicService.getCountry({ dialing_code: cleanDialCode });

      if (response?.status === 1) {
        setCountry(response.data || []);
      } else {
        setCountry([]);
      }
    } catch (error) {
      console.error('getCountry error:', error);
      setCountry([]);
    }
  };

  const getStates = async (dialingCode: string, countryId: string) => {
    try {
      if (!dialingCode) {
        setStates([]);
        setCities([]);
        return;
      }

      const response = await publicService.getState({ dialing_code: dialingCode, country_id: countryId });

      if (response?.status === 1) {
        setStates(response.data || []);
      } else {
        setStates([]);
      }
    } catch (error) {
      console.error('getStates error:', error);
      setStates([]);
    }
  };

  const getCities = async (stateId: string) => {
    try {
      if (!stateId) {
        setCities([]);
        return;
      }

      const response = await publicService.getCity({ state_id: stateId });

      if (response?.status === 1) {
        setCities(response.data || []);
      } else {
        setCities([]);
      }
    } catch (error) {
      console.error('getCities error:', error);
      setCities([]);
    }
  };

  const handleError = (event: any) => {
    // Validate form
    // validating name
    const validateName = formValidation.GetNameValidate(
      formData.name
    );
    // validating existence of genre
    const validateGenre = formValidation.GenreControlIsValid(
      formData.category_ids
    );
    // validating existence of location_id
    const validateLocationId = formValidation.LocationControlIsValid(
      formData.location_id
    );
    setFormErrors({
      name: { ...validateName },
      category_ids: { ...validateGenre },
      location_id: { ...validateLocationId },
    });
  }


  const handlePhoto = (photo_url: string) => {
    setFormData((prevFormData) => {
      const newFormData = { ...prevFormData, photo: photo_url };
      setUpdatedPhoto(photo_url);
      return newFormData;
    });
  };

  useEffect(() => {
    const cleanDialCode = String(formData.country_dial_code || '').replace(/^[+]/, '');

    if (!cleanDialCode) {
      setCountry([]);
      setStates([]);
      setCities([]);
      return;
    }

    // Initial load should populate the country/state lists for the existing dial code.
    // After that, user-entered phone dial code changes should only warn and not reset location.
    if (!countryDialCode || formData.country_dial_code === countryDialCode) {
      getCountry(cleanDialCode);
      getStates(cleanDialCode, formData.country_id);
    }
  }, [formData.country_dial_code, countryDialCode]);

  useEffect(() => {
    if (formData.state_id) {
      getCities(formData.state_id);
    } else {
      setCities([]);
    }
  }, [formData.state_id]);

  useEffect(() => {
    if (updatedPhoto.length > 0) {
      handlePersonalInfoFormData();
    }
    if (email_boolean_fields.verifiedEmail) {
      handlePersonalInfoFormData();
    }
    if (whats_app_boolean_fields.verifiedfield) {
      handlePersonalInfoFormData();
    }
  }, [updatedPhoto, email_boolean_fields.verifiedEmail, whats_app_boolean_fields.verifiedfield]);


  //Handle save and cancel

  const handleEditToggle = (field: string) => {
    setEditableFields((prev: any) => {
      const newState = { ...prev, [field]: !prev[field] };

      // If field is being disabled (Cancel is clicked), reset the form data
      if (!newState[field]) {
        setFormData(initialFormData);
        setSelectedCountry(initialCountry);
        setSelectedState(initialState);
        setSelectedCity(initialCity);
        set_whats_app_boolean_fields(prevState => ({
          ...prevState,
          verifiedfield: false,
          disableWhatsappfieldInput: false,
          disableWhatsappfield: false,
          isEditButtonDisabled: false,
          isResendButtonDisabled: false,
          isTimerDisabled: false,
          showResendEdit: false,
          showotpBox: false,
          verifiedWAfield: false
        }));
        set_email_boolean_fields(prevState => ({
          ...prevState,
          isEditButtonEmailDisabled: false,
          showEmailotpBox: false,
          isResendButtonEmailDisabled: false,
          isEmailTimerDisabled: false,
          showEmailResendEdit: false,
          disableEmailfieldInput: false,
          disableEmailField: false,
          verifiedEmail: false,
          verifiedEmailfield: false
        }));
        setFormErrors({
          name: { status: true, message: '' },
          category_ids: { status: true, message: '' },
          location_id: { status: true, message: '' },
          primary_email: { status: true, message: '' },
          primary_phone: { status: true, message: '' },
        });
        setOtpEmailValue('')
        setOtpWhatsAppValue('')
      }

      setToggleClass(newState.primary_email || newState.primary_phone);
      setToggleClassForOther(newState.name || newState.gender || newState.genre || newState.location);
      return newState;
    });
  };



  const isEditable = Object.entries(editableFields).some(
    ([key, value]) => {
      if (!["primary_email", "primary_phone"].includes(key) && value) {
        return true;
      }
      if (key === "primary_email" && value && email_boolean_fields.verifiedEmail) {
        return true;
      }
      if (key === "primary_phone" && value && whats_app_boolean_fields.verifiedfield) {
        return true;
      }
      return false;
    }
  );


  {/****************** Email *************************/ }
  const handleChangeEmail = () => {
    set_email_boolean_fields((prev) => ({
      ...prev,
      verifiedEmailfield: false,
      showEmailotpBox: false,
      showEmailResendEdit: false,
      disableEmailfieldInput: false
    }))
    if (emailRef.current) {
      emailRef.current.focus();
    }
  }

  const handleEmailChange = (newValue: string) => {
    const filteredValue = newValue.replace(/\D/g, '');
    setOtpEmailValue(filteredValue)
  }

  const handleEmail = async (e: any) => {
    const value = e?.target?.value ?? e;
    setFormData({ ...formData, primary_email: value });

    let isValid = formValidation.GetEmailControlIsValid(value);
    setFormErrors(isValid);

    if (!isValid.status) {
      set_email_boolean_fields({ ...email_boolean_fields, disableEmailField: true });
      return;
    }

    try {
      const response = await publicService.checkEmailIsRegister({
        email: value,
        user_type: "influencer",
      });

      if (response?.data?.status?.message?.length === 0) {
        set_email_boolean_fields({ ...email_boolean_fields, disableEmailField: false });
      } else {
        setVerifiedEmailfield(false);
        set_email_boolean_fields({ ...email_boolean_fields, disableEmailField: true });
      }

      setFormErrors(response.data.status);
    } catch (error) {
      console.error("Error checking email registration:", error);
    }
  };

  const handleEmailOtp = (otp: any) => {
    try {
      if (otp.length === 4) {
        setEmailOtpVerifyLoading(true);
        PublicService.emailVerifyOtp({ email: formData.primary_email, otp: otp })
          .then((res) => {
            if (res.status === gtUtil.Constants.SUCCESS) {
              set_email_boolean_fields((prev) => ({
                ...prev,
                showEmailotpBox: false,
                disableEmailField: true,
                verifiedEmailfield: true,
                verifiedEmail: true,
                showEmailResendEdit: false,

              }));
              setEmailOtpError(false);
              setFormData({ ...formData, email_otp: otp })

              // setIsActiveField({
              //   ...isActiveField,
              //   email: true,
              // })
              localService.toastify(res.info, 'info', 100);
            } else {
              setEmailOtpError(true);
              setEmailOtpErrorMsg(res.info);
              // localService.toastify(res.info);
            }
          })
          .catch((error) => {
            setEmailOtpVerifyLoading(false);
            throw new Error('VerifyOtp Error ::: ' + error);
          });
      }
    } catch (error) {
      console.log('handleEmailOtp Error', error);
    } finally {
      setEmailOtpVerifyLoading(false);
    }
  };

  const handleEmailSendOTP = async () => {
    try {
      if (!formData.primary_email) {
        setFormErrors({ status: true, message: "Email is required." });
        return;
      }
      // Regular expression for email validation
      const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
      if (!emailRegex.test(formData.primary_email)) {
        setFormErrors({
          status: true,
          message: "Invalid email format.",
        });
        return;
      }
      if (!formError?.status) {
        setFormErrors(formValidation.GetEmailControlIsValid(formData.primary_email));
        return;
      }

      setEmailLoading(true)
      // Send email OTP
      const response = await PublicService.emailSendOtp({ email: formData.primary_email });
      // setDisableEmailfieldInput(true)
      set_email_boolean_fields({ ...email_boolean_fields, disableEmailfieldInput: true })
      setEmailLoading(false);
      if (response.status === gtUtil.Constants.SUCCESS) {
        set_email_boolean_fields((prev) => ({
          ...prev,
          showEmailResendEdit: true,
          isResendButtonEmailDisabled: true,
          isEditButtonEmailDisabled: true,
          isEmailTimerDisabled: true,
          showEmailotpBox: true,
          disableEmailField: true
        }));
        setEmailTimer(30);
        localService.toastify(response?.data?.rows?.message);

      } else {
        setFormErrors(response?.data?.rows?.message);
        localService.toastify(response?.data?.rows?.message);
        set_email_boolean_fields({ ...email_boolean_fields, disableEmailfieldInput: false })
      }

    } catch (error) {
      console.warn(`Email OTP Response Error :: ${error}`);
      set_email_boolean_fields({ ...email_boolean_fields, disableEmailfieldInput: false })

    }
  };


  {/************************* WhatsApp *******************************/ }
  const handleWhatsApp = (value: string, data: any) => {
    try {
      const dialCode = data?.dialCode || '';

      // Normalize: remove any non-digit chars and remove leading dial code if present
      let phoneNumber = String(value || '');
      phoneNumber = phoneNumber.replace(/^\+/, '');
      if (dialCode && phoneNumber.startsWith(String(dialCode))) {
        phoneNumber = phoneNumber.slice(String(dialCode).length);
      }

      phoneNumber = phoneNumber.replace(/\D/g, '').slice(0, 15);

      const previousDialCode = formData.dial_code;
      const nextFormData = {
        ...formData,
        primary_phone: phoneNumber,
        dial_code: dialCode,
      };

      if (dialCode && dialCode !== previousDialCode) {
        setShowDialCodeChangeWarning(true);
      }

      setFormData(nextFormData);

      // validation
      let isValid: any = isValidPhoneNumber(phoneNumber, dialCode);

      if(isValid){
         setFormErrors({
          status: true,
          message: "",
        });
        set_whats_app_boolean_fields((prev: any) => ({
          ...prev,
          disableWhatsappfield: false,
        }));
      }else{
        setFormErrors({
          status: false,
          message: "Invalid phone number",
        });

        set_whats_app_boolean_fields((prev: any) => ({
          ...prev,
          disableWhatsappfield: true,
        }));
      }

      // const validation = formValidation.GetMobileControlIsValid(phoneNumber, dialCode);
      // setFormErrors((prevErrors: any) => ({
      //   ...prevErrors,
      //   primary_phone: validation,
      // }));

      // set_whats_app_boolean_fields((prev) => ({
      //   ...prev,
      //   disableWhatsappfield: phoneNumber.length < 6 || !validation.status,
      // }));
    } catch (error) {
      throw new Error(`handleWhatsApp error :: ${error}`);
    }
  };

  const handleSendOtpButton = () => {
    const primaryPhone = formData.primary_phone;
    if (!primaryPhone || !isValidPhoneNumber(formData.primary_phone, formData.dial_code)) {
      localService.toastify("Please provide a valid phone number", "error", 1000);
      return; // Prevent further execution
    }

    set_whats_app_boolean_fields({ ...whats_app_boolean_fields, disableWhatsappfieldInput: true });
    // const isValid: any = formValidation.GetMobileControlIsValid(primaryPhone, formData.dial_code);
    // setFormErrors(isValid);
    let isValid: any = isValidPhoneNumber(primaryPhone, formData.dial_code);
    // set_whats_app_boolean_fields({ ...whats_app_boolean_fields, disableWhatsappfieldInput: true })
    if(isValid){
      setFormErrors({
        status: true,
        message: ''
      })
    }
    if (!isValid) return;

    PublicService.sendOtpGlobal({ mobile: +primaryPhone, dial_code: formData.dial_code })
      .then((res: any) => {
        if (res.status === gtUtil.Constants.SUCCESS) {
          set_whats_app_boolean_fields((prev) => ({
            ...prev,
            showResendEdit: true,
            isResendButtonDisabled: true,
            isTimerDisabled: true,
            showotpBox: res.status === gtUtil.Constants.SUCCESS,
            disableWhatsappfield: res.status === gtUtil.Constants.SUCCESS,
          }));
          setTimer(30);
          localService.toastify(res.info, "success", 1000);
        } else {
          localService.toastify(res.info, "error", 1000);
          set_whats_app_boolean_fields((prev) => ({
            ...prev,
            disableWhatsappfieldInput: false,
            verifiedWAfield: false,
          }));
        }
        setPhoneLoading(false);
      })
      .catch((error: any) => {
        setPhoneLoading(false);
        set_whats_app_boolean_fields((prev) => ({
          ...prev,
          disableWhatsappfieldInput: false,
          verifiedWAfield: false,
        }));
        console.warn(`Otp Response Error :: ${error}`);
      });
  };


  const handleChangePhone = () => {
    set_whats_app_boolean_fields((prev) => ({
      ...prev,
      disableWhatsappfieldInput: false,
      showotpBox: false,
      showResendEdit: false,
      verifiedWAfield: false
    }));
    if (phoneRef.current) {
      phoneRef.current.focus();
    }
  }

  const handleWhatsAppChange = (newValue: string) => {
    const filteredValue = newValue.replace(/\D/g, ''); // Replace any non-digit character
    setOtpWhatsAppValue(filteredValue);
  }

  const validateChar = (value: string) => {
    // return matchIsNumeric(value);
    return /^\d*$/.test(value);
  };

  // const isPhoneValid = (): boolean => {
  //   try {
  //     const validation = formValidation.GetMobileControlIsValid(formData.primary_phone || '', formData.dial_code || '');
  //     return !!validation && validation.status === true;
  //   } catch (error) {
  //     return false;
  //   }
  // };

  const handleWhatsAppOtp = (otp: any) => {
    try {
      // Ensure primary_phone is not null
      const primaryPhone = formData.primary_phone;
      if (!primaryPhone) {
        localService.toastify("Please provide a valid phone number", "error", 1000);
        return; // Exit if the phone number is invalid
      }
      // Continue if OTP length is valid (4 digits)
      if (otp.length === 4) {
        setPhoneOtpVerifyLoading(true);
        PublicService.verifyOtpGlobal({ mobile: +primaryPhone, otp: otp, dial_code: formData.dial_code })
          .then((res) => {
            if (res.status === gtUtil.Constants.SUCCESS) {
              set_whats_app_boolean_fields((prev) => ({
                ...prev,
                showResendEdit: false,
                showotpBox: false,
                disableWhatsappfield: true,
                verifiedfield: true,
                verifiedWAfield: true
              }));
              localService.toastify(res?.data?.rows?.message, "success", 1000);
              setPhoneOtpError(false);
              setFormData({ ...formData, phone_otp: otp });

              if (formData.dial_code && formData.dial_code !== initialDialCode) {
                setShowDialCodeChangeWarning(true);
              }

            } else {
              setPhoneOtpError(true);
              setPhoneOtpErrorMsg(res.info);
            }
          })
          .catch((error) => {
            setPhoneOtpVerifyLoading(false);
            throw new Error("VerifyOtp Error ::: " + error);
          });
      } else {
        setPhoneOtpError(true);
        setPhoneOtpErrorMsg("OTP must be 4 digits long");
      }
    } catch (error) {
      console.log('handleWhatsAppOtp error', error);
    } finally {
      setPhoneOtpVerifyLoading(false);
    }
  };

  return (
    <>
      <form onSubmit={handlePersonalInfoFormData} className='mb-4 personal-info-mobile'>
        <div className='p-0  _influencer_setting_personal_info_main'>
          <div className='list-section-content rounded'>
            <strong className=''>Personal Information</strong>
          </div>

          <div>
            <div className='row mb-3'>
              <div className='col-auto _influencer_setting_img d-none d-md-flex'>
                {loading ? <Skeleton variant="circular" height={100} width={100} /> :
                  <> {cameraIcon ? <img
                    onClick={() => { setShowUploadPopup(!showUploadPopup) }}
                    src={formData.photo === ''
                      ? DefaultUserProfile.influencer_unknown_default
                      : formData.photo}
                    alt="User"
                    style={{ position: "relative", cursor: 'pointer' }}
                  /> : <img
                    src={formData.photo === ''
                      ? DefaultUserProfile.influencer_unknown_default
                      : formData.photo}
                    alt="User"
                    style={{ position: "relative" }
                    } />
                  }
                  </>
                }

                {<AddAPhotoIcon className='add-photo-icon'
                  onClick={() => { setShowUploadPopup(!showUploadPopup) }} />}

                <div className='col-lg-3 '>
                  {showUploadPopup && (
                    <FileUploadPopup openModal={showUploadPopup} onClose={(e) => setShowUploadPopup(false)} onSend={(e) => handlePhoto(e.url)}
                      path={path}
                      acceptedFileTypes=".jpg, .jpeg, .png" />
                  )}
                </div>
              </div>
              <div className='col position-relative'>
                {loading ? <Skeleton height={40} /> :
                  <>
                    <TextField
                      fullWidth
                      label='Name'
                      name='name'
                      variant='standard'
                      value={formData?.name}
                      disabled={!editableFields.name}
                      error={!!formError?.name && !formError?.name?.status}
                      helperText={
                        formError?.name?.message
                      }
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          name: e.target.value,
                        })
                      }
                      onBlur={handleError}
                    />
                    <span
                      className={toggleClass ? 'info_edit_personal_disabled' : 'info_edit_personal'}
                      style={{ top: "23%", right: "12px", cursor: "pointer" }}
                      onClick={() => handleEditToggle("name")}
                    >
                      {editableFields.name ? "Cancel" : "Edit"}
                    </span>
                  </>
                }
              </div>
            </div>
          </div>
          <Grid container rowSpacing={2} spacing={2}>
            <Grid item xs={12} md={6} className='mb-2'>
              {loading ? <Skeleton height={40} /> :
                <div className="__wa_column">
                  <TextField
                    className={`w-100 input-style input-common ${email_boolean_fields.verifiedEmail ? "verified-email" : ""}`}
                    // disabled={!isActiveField.mobile}
                    disabled={!editableFields.primary_email}
                    size="small"
                    id="primary_email"
                    onChange={handleEmail}
                    name="primary_email"
                    label="Your Email Id"
                    variant="outlined"
                    inputRef={emailRef}
                    value={formData.primary_email}
                    InputProps={{ readOnly: email_boolean_fields.disableEmailfieldInput }}
                    onPaste={(e: any) => formValidation.GethandlePaste(e, setEmail, "email", (trimmedData) => handleEmail({ target: { value: trimmedData } }))}
                    onKeyDown={(e: any) => formValidation.GetHandleKeyDown(e, setEmail, email, "email")}
                  />
                  <span
                    className={(
                      (toggleClass && !editableFields.primary_email) || (toggleClassForOther && !editableFields.primary_email)
                    ) ? 'info_edit_personal_disabled' : 'info_edit_personal'}
                    onClick={() => handleEditToggle("primary_email")}
                  >
                    {editableFields.primary_email ? "Cancel" : "Edit"}
                  </span>

                  {editableFields.primary_email && !email_boolean_fields.verifiedEmail && (
                    <LoadingButton
                      className={`__button __button-influender ${email_boolean_fields.disableEmailField ? "btn-disabled" : ""}`}
                      color="success"
                      loading={emailloading}
                      loadingPosition="start"
                      variant="contained"
                      startIcon={<SendIcon />}
                      onClick={handleEmailSendOTP}
                      disabled={email_boolean_fields.disableEmailField}
                    >
                      {emailOtpSent ? "OTP Sent" : "Send OTP"}
                    </LoadingButton>
                  )}

                  {email_boolean_fields.verifiedEmail &&
                    <Tooltip className="icon-verified" title="verified" arrow>
                      <IconButton size="small" className="p-0">
                        <MaterialSymbol iconName="verified" fontweight="200" />
                      </IconButton>
                    </Tooltip>
                  }
                  {editableFields.primary_email && <span className="error">{formError?.message}</span>}
                  {email_boolean_fields.showEmailResendEdit &&
                    <div className="resend-otp d-flex align-items-center w-100 mb-2">
                      {email_boolean_fields.isEditButtonEmailDisabled && <p className="change-phone fs-12 btn btn-text-link me-auto my-0" onClick={handleChangeEmail}>Change Email</p>}
                      <div className="resend-otp-container d-flex">
                        <button
                          className="otp-btn fs-12 btn btn-text-link"
                          onClick={handleEmailSendOTP}
                          type="button"
                          disabled={email_boolean_fields.isResendButtonEmailDisabled}
                        >
                          Resend OTP
                        </button>
                        {email_boolean_fields.isEmailTimerDisabled && <p className="otp-time fs-12 my-0">&nbsp; 00:{Emailtimer < 10 ? `0${Emailtimer}` : Emailtimer}</p>}
                      </div>

                    </div>
                  }

                  {email_boolean_fields.showEmailotpBox &&
                    <div className="mobile-verification">
                      <MuiOtpInput
                        className="otp-fields"
                        value={otpEmailValue}
                        onChange={handleEmailChange}
                        length={4}
                        autoFocus
                        TextFieldsProps={{ size: 'small', placeholder: '0', type: "tel" }}
                        validateChar={validateChar}
                      />

                      <LoadingButton
                        className="verify-button"
                        loading={emailOtpVerifyloading}
                        variant="contained"
                        color="success"
                        disabled={otpEmailValue.length == 4 ? false : true}
                        onClick={() => handleEmailOtp(otpEmailValue)}
                      >
                        Verify
                      </LoadingButton>
                    </div>
                  }
                  {emailOtpError && <span className="error">{emailOtpErrorMsg}</span>}
                </div>
              }
            </Grid>
            <Grid item xs={12} md={6} className='position-relative mb-2'>
              {loading ? <Skeleton height={40} /> :
                <div>
                  <FormControl disabled
                    className='w-100 input-style'
                    size='small'
                  >
                    <InputLabel id='demo-simple-select-label' className='mt-0'>
                      Gender
                    </InputLabel>

                    <Select
                      className='influencer_personal_info mt-0'
                      labelId='demo-simple-select-label'
                      id='influencer-gender'
                      value={formData?.gender}
                      name='gender'
                      displayEmpty
                      disabled={!editableFields.gender}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          gender: e.target.value,
                        })
                      }
                      input={<OutlinedInput label='Gender' />}
                      MenuProps={MenuPropsSelect}
                    >
                      <MenuItem value={'Male'}>Male</MenuItem>
                      <MenuItem value={'Female'}>Female</MenuItem>
                      <MenuItem value={'Other'}>Other</MenuItem>
                    </Select>
                  </FormControl>
                  {/* <span
                    className={toggleClass ? 'info_edit_personal_disabled' : 'info_edit_personal'}
                    onClick={() => handleEditToggle("gender")}
                  >
                    {editableFields.gender ? "Cancel" : "Edit"}
                  </span> */}
                </div>
              }
            </Grid>
            <Grid item xs={12} md={6} className='mb-2'>
              {loading ? <Skeleton height={40} /> :
                <div className="__wa_column __wa_column_mobile">
                  <div
                    className="d-flex"
                    onClickCapture={(e: any) => {
                      // The phone prefix/flag is locked — a tap on it explains why.
                      if (e.target?.closest?.('.flag-dropdown, .selected-flag')) {
                        notifyLockedRegionField();
                      }
                    }}
                  >
                    {/* <TextField
                      disabled={!editableFields.primary_phone}
                      className="w-100 input-style input-common"
                      type="number"
                      size="small"
                      color="primary"
                      InputProps={{
                        readOnly: whats_app_boolean_fields.disableWhatsappfieldInput,
                        inputMode: 'numeric',
                        startAdornment: (<InputAdornment position="start"><span className="fs-14 font-weight-normal">+91</span></InputAdornment>),
                      }}
                      inputRef={phoneRef}
                      onChange={handleWhatsApp}
                      name="whatsapp_number"
                      value={formData.primary_phone}
                      id="whatsapp_number_id"
                      label="WhatsApp No."
                      variant="outlined"

                      onKeyDown={(e: any) => formValidation.GetHandleKeyDown(e, setWhatsAppNumber, whatsappnumber, 'number', setFormErrors)}
                      onPaste={(e: any) => formValidation.GethandlePaste(e, setWhatsAppNumber, "phone", (trimmedData) => handleWhatsApp({ target: { value: trimmedData } }))}
                    /> */}
                    <PhoneInput
                      key={onlyCountries.join(",")}
                      country={"in"}
                      onlyCountries={onlyCountries}
                      enableSearch={true}
                      disableSearchIcon={true}
                      // Phone prefix (country code) is LOCKED — always disable the
                      // flag dropdown so it can't be changed here (the number can
                      // still be edited). A tap shows a "contact support" message
                      // via the wrapper's onClickCapture below.
                      disableDropdown={true}
                      countryCodeEditable={false}

                      value={`${formData.dial_code || "91"}${formData.primary_phone || ""}`}

                      onChange={handleWhatsApp}

                      inputStyle={{
                        width: "100%",
                        height: "40px",
                      }}

                      containerStyle={{
                        width: "100%",
                      }}
                      containerClass={(!editableFields.primary_phone) ? 'phone-input-disabled' : ''}
                      inputClass={(!editableFields.primary_phone) ? 'phone-input-disabled-field' : ''}

                      dropdownStyle={{
                        zIndex: 9999,
                      }}

                      inputProps={{
                        name: "primary_phone",
                        required: true,
                        autoFocus: false,
                        disabled: !editableFields.primary_phone,
                        readOnly: whats_app_boolean_fields.disableWhatsappfieldInput,
                        ref: phoneRef,
                        onPaste: (e: any) => formValidation.GethandlePaste(e, setWhatsAppNumber, "phone", (trimmedData: string) => handleWhatsApp(`${formData.dial_code || '91'}${trimmedData}`, { dialCode: formData.dial_code || '91' })),
                      }}
                    />
                    <span
                      className={(
                        (toggleClass && !editableFields.primary_phone) || (toggleClassForOther && !editableFields.primary_phone)
                      ) ? 'info_edit_personal_disabled' : 'info_edit_personal'}
                      onClick={() => handleEditToggle("primary_phone")}
                    >
                      {editableFields.primary_phone ? "Cancel" : "Edit"}
                    </span>
                    {editableFields.primary_phone && !whats_app_boolean_fields.verifiedfield &&
                      <LoadingButton
                        className={`__button __button-influender ${!isValidPhoneNumber(formData.primary_phone, formData.dial_code) ? "btn-disabled" : ""}`}
                        loading={phoneloading}
                        loadingPosition="start"
                        variant="contained"
                        startIcon={<WhatsAppIcon />}
                        color="success"
                        disabled={!isValidPhoneNumber(formData.primary_phone, formData.dial_code)}
                        onClick={handleSendOtpButton}
                      >
                        Send OTP
                      </LoadingButton>
                    }
                    {whats_app_boolean_fields.verifiedfield &&
                      <Tooltip className="icon-verified" title="verified" arrow>
                        <IconButton size="small" className="p-0">
                          <MaterialSymbol iconName="verified" fontweight="200" />
                        </IconButton>
                      </Tooltip>
                    }
                  </div>
                  {editableFields.primary_phone && <span className="error">{formError?.message}</span>}
                  {whats_app_boolean_fields.showResendEdit &&
                    <div className="resend-otp d-flex align-items-center w-100 mb-2">
                      {whats_app_boolean_fields.isEditButtonDisabled && <p className="change-phone fs-12 btn btn-text-link me-auto my-0" onClick={handleChangePhone}>Change Phone</p>}
                      <div className="resend-otp-container d-flex">
                        <button
                          className="otp-btn fs-12 btn btn-text-link"
                          onClick={handleSendOtpButton}
                          type="button"
                          disabled={whats_app_boolean_fields.isResendButtonDisabled}
                        >
                          Resend OTP
                        </button>
                        {whats_app_boolean_fields.isTimerDisabled && <p className="otp-time fs-12 my-0">&nbsp; 00:{timer < 10 ? `0${timer}` : timer}</p>}
                      </div>

                    </div>
                  }
                  {/* {whats_app_boolean_fields.showotpBox && <OtpField handleOtp={handleWhatsAppOtp} />} */}
                  {whats_app_boolean_fields.showotpBox &&
                    <div className="mobile-verification">
                      <MuiOtpInput
                        className="otp-fields"
                        value={otpWhatsAppValue}
                        onChange={handleWhatsAppChange}
                        length={4}
                        autoFocus
                        TextFieldsProps={{ size: 'small', placeholder: '0', type: "tel" }}
                        validateChar={validateChar}
                      />

                      <LoadingButton
                        className="verify-button"
                        loading={phoneOtpVerifyloading}
                        variant="contained"
                        color="success"
                        disabled={otpWhatsAppValue.length == 4 ? false : true}
                        onClick={() => handleWhatsAppOtp(otpWhatsAppValue)}
                      >
                        Verify
                      </LoadingButton>
                    </div>
                  }
                  {phoneOtpError && <span className="error">{phoneOtpErrorMsg}</span>}
                </div>
              }
            </Grid>
            <Grid item xs={12} md={6} className='mb-2'>
              <Grid className='d-flex align-items-start date_picker_container'>
                {loading ? <Skeleton height={40} /> :
                  <><LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['DatePicker']}>
                      {formData?.dob && (
                        <DatePicker
                          className='input-style date_picker'
                          label='Date of Birth'
                          defaultValue={dayjs(formData?.dob)}
                          disabled={true}
                          format='DD/MM/YYYY'
                          onChange={handleDob}
                          minDate={dayjs(minDate)}
                          maxDate={dayjs(maxDate)}
                        />
                      )}
                    </DemoContainer>
                  </LocalizationProvider>

                    {formData?.age && (
                      <TextField
                        size='small'
                        className='ms-2 influencer_personal_info input-style influencer_personal_info-age'
                        type='age'
                        id='age'
                        label='Age'
                        variant='outlined'
                        disabled={true}
                        style={{ width: '60px' }}
                        value={formData?.age}
                      />
                    )}</>
                }
              </Grid>
            </Grid>
            <Grid item xs={12} md={6} className='position-relative mb-2'>
              {loading ? <Skeleton height={40} /> :
                <>
                  <FormControl
                    className='w-100 input-style'
                    size='small'
                    disabled={disableField}
                  >
                    <InputLabel id='demo-multiple-name-label'>
                      Genre (Max. 3)
                    </InputLabel>
                    <Select
                      disabled={!editableFields.genre}
                      className='_genre_option influencer_personal_info'
                      labelId='demo-multiple-name-label'
                      id='Genre_id'
                      multiple
                      value={formData?.category_ids}
                      onChange={handleGenre}
                      onBlur={handleError}
                      input={<OutlinedInput label='Genre (Max. 3)' />}
                      MenuProps={MenuPropsSelect}
                      name='genre'
                      error={!formError?.category_ids?.status}
                    >
                      {masterCategories ? (
                        masterCategories?.map((res: any) => (
                          <MenuItem
                            key={res.category_id}
                            value={String(res.category_id)}
                            style={getStyles(
                              res.category,
                              formData?.category_ids,
                              theme
                            )}
                          >
                            {res.category}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem
                          key={1}
                          value='1'
                          style={getStyles(
                            'No Data',
                            formData?.category_ids,
                            theme
                          )}
                        >
                          {'No Data'}
                        </MenuItem>
                      )}
                    </Select>
                    {!formError?.category_ids?.status && (
                      <FormHelperText style={{ color: 'red' }}>
                        {formError?.category_ids?.message}
                      </FormHelperText>
                    )}
                  </FormControl>
                  <span
                    className={toggleClass ? 'info_edit_personal_disabled' : 'info_edit_personal'}
                    onClick={() => handleEditToggle("genre")}
                  >
                    {editableFields.genre ? "Cancel" : "Edit"}
                  </span>
                </>
              }
            </Grid>
            <Grid item xs={12} md={6} className='position-relative mb-2'>
              {loading ? <Skeleton height={40} /> :
                <>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                      {/* Country is locked (fixed to the signup region). Always
                          disabled; the wrapper shows a "contact support" message
                          when a user taps it. */}
                      <div onClick={notifyLockedRegionField} style={{ cursor: 'pointer' }}>
                      <Autocomplete
                        className='influencer_personal_info'
                        size='small'
                        disablePortal
                        disabled
                        id='country-select'
                        options={country || []}
                        getOptionLabel={(option: any) => option?.name || ''}
                        isOptionEqualToValue={(option: any, value: any) => option?.id === value?.id}
                        value={country.find((c: any) => c.id == selectedCountry) || null}
                        onChange={handleCountryChange}
                        ListboxProps={MenuPropsAutoCompleteNoCheckBox.PaperProps}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label='Country'
                          />
                        )}
                      />
                      </div>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Autocomplete
                        className='influencer_personal_info'
                        size='small'
                        disablePortal
                        disabled={!editableFields.location || !selectedCountry}
                        id='state-select'
                        options={states || []}
                        getOptionLabel={(option: any) => option?.name || ''}
                        isOptionEqualToValue={(option: any, value: any) => option?.id === value?.id}
                        value={states.find((s: any) => s.id == selectedState) || null}
                        onChange={handleStateChange}
                        ListboxProps={MenuPropsAutoCompleteNoCheckBox.PaperProps}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label='State'
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Autocomplete
                        className='influencer_personal_info'
                        size='small'
                        disablePortal
                        disabled={!editableFields.location || !selectedState}
                        id='city-select'
                        options={cities || []}
                        getOptionLabel={(option: any) => option?.name || ''}
                        isOptionEqualToValue={(option: any, value: any) => option?.id === value?.id}
                        value={cities.find((c: any) => c.id == selectedCity) || null}
                        onChange={handleCityChange}
                        ListboxProps={MenuPropsAutoCompleteNoCheckBox.PaperProps}
                        renderInput={(params) => (
                          <TextField
                            name='location'
                            {...params}
                            label='City'
                            error={!!formError?.location_id && !formError.location_id.status}
                            helperText={formError?.location_id?.message}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                  <span
                    className={toggleClass ? 'info_edit_personal_disabled' : 'info_edit_personal'}
                    onClick={() => handleEditToggle("location")}
                  >
                    {editableFields.location ? "Cancel" : "Edit"}
                  </span>
                </>
              }
            </Grid>
          </Grid>
          <div className='col-auto pt-3 btn-fixed-bottom'>
            <Button
              size='small'
              type='submit'
              variant='contained'
              className='btn btn-primary btn-mui btn-lg'
              // disabled={!Object.values(editableFields).includes(true)} 
              disabled={!isEditable}
              onClick={handlePersonalInfoFormData}
            >
              Save
            </Button>
          </div>

          <Dialog
            open={showDialCodeChangeWarning}
            onClose={() => setShowDialCodeChangeWarning(false)}
            aria-labelledby='dialcode-warning-title'
          >
            <DialogTitle id='dialcode-warning-title'>Update country and location</DialogTitle>
            <DialogContent>
              <DialogContentText>
                You changed your phone dial code. Please update your Country, State and City to match the new country dial code.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setShowDialCodeChangeWarning(false)} color='primary'>
                OK
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </form>

    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    userData: state.UserReducer.UserData
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    loading: (data: any) => dispatch(Loading(data)),
    updateAccountImage: (data: any) => dispatch(UserLogin(data)),
    updateUser: (data: any) => dispatch(UserLogin(data))
  };
};

const connectToRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(InfluencerPersonalInfo);
export { connectToRedux as InfluencerPersonalInfo };
